<template>
  <transition name="fade">
    <div class="stripe-connect-notification" v-if="showStripeConnectNotification">
      <StripeConnect @skip="skip"/>
    </div>
  </transition>

  <suspense>
    <router-view/>
  </suspense>
</template>

<script setup>
import StripeConnect from "./components/StripeConnect";
import {computed} from "vue";
import {useStore} from "vuex";

const store = useStore();

const showStripeConnectNotification = computed(() => {
  return store.getters['auth/registrationCompleted']
    && !store.getters['user/stripeConnectSkipped']
    && !store.getters['auth/user']?.onboard_completed;
});
const skip = () => store.dispatch('user/skipStripeConnect', true);
</script>

<style lang="scss" scoped>
@import "./assets/sass/_theme_variables.scss";

.stripe-connect-notification {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: $bg;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  justify-items: center;
  padding: toRem(16);
}
</style>
